import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Renderer2, ApplicationRef, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { first } from "rxjs";
import { NgOtpInputComponent } from 'ng-otp-input';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss']
})
export class OtpInputComponent implements OnInit, AfterViewInit {
  @ViewChild('otpInputField') public ngOtpInput: NgOtpInputComponent;
  @Output() otpEntryChange = new EventEmitter<{otpInput: string, submit: boolean}>();

  public readonly DEFAULT_OTP_CODE_LENGTH = 6;
  public readonly OTP_INPUT_CONFIG = { length: this.DEFAULT_OTP_CODE_LENGTH, showErrors:true, separator: '-'};

  public otpEntryForm: UntypedFormGroup;
  public renderForm = false;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly host: ElementRef,
    private readonly renderer: Renderer2,
    private readonly appRef: ApplicationRef,
    private readonly cdr: ChangeDetectorRef) { }

  public ngOnInit() {
    this.otpEntryForm = this.formBuilder.group({otp: ['', [Validators.required, Validators.maxLength(this.DEFAULT_OTP_CODE_LENGTH), Validators.pattern("^[0-9]*$")]]});
  }
    
  // Defer creating the form DOM by one to avoid change detection cycle status flips in nested forms
  // Ideally, we should remove the nested forms that are used in the email-otp general, and motp components, this is a to do refactor
  public ngAfterViewInit() {
    setTimeout(() => {
      this.renderForm = true;
      this.focusOtpFirst();
      this.addMobileFriendlyTags();
      this.cdr.detectChanges();
    });
  }

  /**
   * Emits the valid OTP entry
   * Handles form validation, and presents error messages if the OTP is invalid by marking form as dirty when needed
   * @param value The OTP value as provided in the form control/OTP field
   */
  public emitValidOtp(value: string) {
    if (value?.length === this.DEFAULT_OTP_CODE_LENGTH) {
      if(this.otpEntryForm.valid) {
        this.emitOtpEntry();
      }
      else {
        this.otpEntryForm.controls['otp'].markAsDirty();
      }
    }
    else if(!this.otpEntryForm.valid) { // If the user enters some invalid key(like enter) trigger error display
      this.otpEntryForm.controls['otp'].markAsDirty();
    }
  }

  // The NPM package we are now using, does not include an option for inputmode, which is important for mobile
  // So, here, we add these helpful attributes manually. There is a newwer package available that supports it, but requires Angular 17+
  private addMobileFriendlyTags() {
    setTimeout(() => {
      const inputs: NodeListOf<HTMLInputElement> = this.host.nativeElement.querySelectorAll('ng-otp-input input.otp-input');
      inputs.forEach((el) => {
        this.renderer.setAttribute(el, 'inputmode', 'numeric');
        this.renderer.setAttribute(el, 'pattern', '^[0-9]*');
      });
    });
  }

  /**
   * Ensures all the components are loaded, then focuses the first OTP field by using registered view child.
   */
  private focusOtpFirst() {
    this.appRef.isStable
      .pipe(first(isStable => isStable))
      .subscribe(() => {
        if(this.ngOtpInput) {
          const eleId = this.ngOtpInput.getBoxId(0);
          const firstOtpField = document.getElementById(eleId);
          firstOtpField?.focus();  
        }
      });
  }

  /**
   * Emits the valid OTP entry and resets the form
   * @precondition The OTP should be validated already, this function does not validate the value
   */
  private emitOtpEntry(): void {
    this.otpEntryChange.emit({'otpInput' : this.otpEntryForm.get('otp').value, 'submit' : true});
    this.otpEntryForm.reset();
  }
}
